import { RequestsActionTypes } from "./constants";

const INIT_STATE = {
  list: [],
  total: 0,
  one: null,
  loading: false,
};

interface RequestCreate {
  country: string;
  comment: string;
  description: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
}

interface RequestsData {
  items?: any[];
  total?: number;
}

interface GetRequestsData {
  id: string;
}

interface RequestsActionType {
  type:
    | RequestsActionTypes.GET_LIST_REQUESTS
    | RequestsActionTypes.GET_LIST_REQUESTS_ERROR
    | RequestsActionTypes.GET_LIST_REQUESTS_SUCCESS
    | RequestsActionTypes.CREATE_REQUEST
    | RequestsActionTypes.CREATE_REQUEST_SUCCESS
    | RequestsActionTypes.CREATE_REQUEST_ERROR
    | RequestsActionTypes.GET_REQUEST
    | RequestsActionTypes.GET_REQUEST_SUCCESS
    | RequestsActionTypes.GET_REQUEST_ERROR
    | RequestsActionTypes.UPDATE_REQUEST
    | RequestsActionTypes.UPDATE_REQUEST_SUCCESS
    | RequestsActionTypes.UPDATE_REQUEST_ERROR
    | RequestsActionTypes.UPDATE_STATUS_REQUEST
    | RequestsActionTypes.UPDATE_STATUS_REQUEST_SUCCESS
    | RequestsActionTypes.UPDATE_STATUS_REQUEST_ERROR
    | RequestsActionTypes.DELETE_REQUEST
    | RequestsActionTypes.DELETE_REQUEST_SUCCESS
    | RequestsActionTypes.DELETE_REQUEST_ERROR
    | RequestsActionTypes.ASSIGN_AGENTS
    | RequestsActionTypes.ASSIGN_AGENTS_SUCCESS
    | RequestsActionTypes.ASSIGN_AGENTS_ERROR
    | RequestsActionTypes.SUBMIT_QUOTE
    | RequestsActionTypes.SUBMIT_QUOTE_SUCCESS
    | RequestsActionTypes.SUBMIT_QUOTE_ERROR
    | RequestsActionTypes.APPROVE_QUOTE
    | RequestsActionTypes.APPROVE_QUOTE_SUCCESS
    | RequestsActionTypes.APPROVE_QUOTE_ERROR;
  payload: {
    actionType?: string;
    data?: RequestsData;
    createData?: RequestCreate;
    getRequest?: GetRequestsData;
    error?: string;
    requestCreateError?: string;
    updated: false;
    refreshList: false;
  };
}

interface State {
  list?: any[];
  total?: number;
  one?: any;
  loading?: boolean;
  value?: boolean;
}

const Requests = (
  state: State = INIT_STATE,
  action: RequestsActionType
): any => {
  switch (action.type) {
    case RequestsActionTypes.GET_REQUEST:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        requestCreateError: "",
        total: 0,
        updated: false,
      };
    case RequestsActionTypes.GET_REQUEST_SUCCESS:
      switch (action.payload.actionType) {
        case RequestsActionTypes.GET_REQUEST: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            requestCreateError: "",
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case RequestsActionTypes.GET_REQUEST_ERROR:
      switch (action.payload.actionType) {
        case RequestsActionTypes.GET_REQUEST: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            requestCreateError: action.payload.error,
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case RequestsActionTypes.CREATE_REQUEST:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        requestCreateError: "",
        total: 0,
      };
    case RequestsActionTypes.CREATE_REQUEST_SUCCESS:
      switch (action.payload.actionType) {
        case RequestsActionTypes.CREATE_REQUEST: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            requestCreateError: "",
          };
        }
        default:
          return { ...state };
      }

    case RequestsActionTypes.CREATE_REQUEST_ERROR:
      switch (action.payload.actionType) {
        case RequestsActionTypes.CREATE_REQUEST: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            requestCreateError: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case RequestsActionTypes.UPDATE_REQUEST:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        requestCreateError: "",
        total: 0,
      };
    case RequestsActionTypes.UPDATE_REQUEST_SUCCESS:
      switch (action.payload.actionType) {
        case RequestsActionTypes.UPDATE_REQUEST: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            requestCreateError: "",
            updated: true,
          };
        }
        default:
          return { ...state };
      }

    case RequestsActionTypes.UPDATE_REQUEST_ERROR:
      switch (action.payload.actionType) {
        case RequestsActionTypes.UPDATE_REQUEST: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            requestCreateError: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case RequestsActionTypes.UPDATE_STATUS_REQUEST:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        requestCreateError: "",
        total: 0,
        refreshList: false,
      };
    case RequestsActionTypes.UPDATE_STATUS_REQUEST_SUCCESS:
      switch (action.payload.actionType) {
        case RequestsActionTypes.UPDATE_STATUS_REQUEST: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            requestCreateError: "",
            updated: true,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case RequestsActionTypes.UPDATE_STATUS_REQUEST_ERROR:
      switch (action.payload.actionType) {
        case RequestsActionTypes.UPDATE_STATUS_REQUEST: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            requestCreateError: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case RequestsActionTypes.GET_LIST_REQUESTS_SUCCESS:
      switch (action.payload.actionType) {
        case RequestsActionTypes.GET_LIST_REQUESTS: {
          return {
            ...state,
            list: action.payload.data.items,
            loading: false,
            total: action.payload.data.total,
            one: null,
            error: "",
            requestCreateError: "",
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case RequestsActionTypes.GET_LIST_REQUESTS_ERROR:
      switch (action.payload.actionType) {
        case RequestsActionTypes.GET_LIST_REQUESTS: {
          return {
            ...state,
            error: action.payload.error,
            list: [],
            total: 0,
            loading: false,
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case RequestsActionTypes.GET_LIST_REQUESTS:
      return {
        ...state,
        loading: true,
        list: [],
        total: 0,
        one: null,
        error: "",
        requestCreateError: "",
        updated: false,
        refreshList: false,
        agentAssigned: false,
        quoteSubmitted: false,
        quoteApproved: false,
      };
    case RequestsActionTypes.DELETE_REQUEST:
      return {
        ...state,
        refreshList: false,
      };
    case RequestsActionTypes.DELETE_REQUEST_SUCCESS:
      switch (action.payload.actionType) {
        case RequestsActionTypes.DELETE_REQUEST: {
          return {
            ...state,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case RequestsActionTypes.DELETE_REQUEST_ERROR:
      switch (action.payload.actionType) {
        case RequestsActionTypes.DELETE_REQUEST: {
          return {
            ...state,
            error: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }
    case RequestsActionTypes.ASSIGN_AGENTS:
      return { ...state, loading: true, agentAssignError: "", agentAssigned: false };
    case RequestsActionTypes.ASSIGN_AGENTS_SUCCESS:
      return { ...state, loading: false, one: action.payload.data, agentAssigned: true, agentAssignError: "" };
    case RequestsActionTypes.ASSIGN_AGENTS_ERROR:
      return { ...state, loading: false, agentAssignError: action.payload.error, agentAssigned: false };

    case RequestsActionTypes.SUBMIT_QUOTE:
      return { ...state, loading: true, quoteSubmitError: "", quoteSubmitted: false };
    case RequestsActionTypes.SUBMIT_QUOTE_SUCCESS:
      return { ...state, loading: false, one: action.payload.data, quoteSubmitted: true, quoteSubmitError: "" };
    case RequestsActionTypes.SUBMIT_QUOTE_ERROR:
      return { ...state, loading: false, quoteSubmitError: action.payload.error, quoteSubmitted: false };

    case RequestsActionTypes.APPROVE_QUOTE:
      return { ...state, loading: true, quoteApproveError: "", quoteApproved: false };
    case RequestsActionTypes.APPROVE_QUOTE_SUCCESS:
      return { ...state, loading: false, one: action.payload.data, quoteApproved: true, refreshList: true, quoteApproveError: "" };
    case RequestsActionTypes.APPROVE_QUOTE_ERROR:
      return { ...state, loading: false, quoteApproveError: action.payload.error, quoteApproved: false };

    default:
      return { ...state };
  }
};

export default Requests;
